core.component('coreAvisosComponent', {
    templateUrl: 'components/avisos/avisos.html',
    controller: ['$rootScope', '$sce', 'coreLanguage', '$scope', function($rootScope, $sce, $text, $scope){

        var $ctrl = this;
        $scope.$text = $text;

        $ctrl.toggleLoading = (dialog) => {
            dialog.isLoading = !dialog.isLoading;
        };

        $ctrl.trust=(value)=>{
            return $sce.trustAsHtml(value);
        };

        $ctrl.getIdx=()=>{
            let idsAvisos = $ctrl.avisos.map(item=>{ return item.id });

            let idx = idsAvisos.indexOf($ctrl.aviso.id);
            return idx;
        };

        $ctrl.prevAviso=()=>{
            let idx = $ctrl.getIdx() - 1;
            if(idx < 0){ return; }

            $ctrl.aviso = $ctrl.avisos[idx];
        };
        
        $ctrl.nextAviso=()=>{
            let idx = $ctrl.getIdx() + 1;
            if(idx >= $ctrl.avisos.length){ return; }
            
            $ctrl.aviso = $ctrl.avisos[idx];
        };

        $rootScope.$watch('avisoCfg', (newVal, oldVal)=>{ 
            if(newVal){
                $ctrl.readAll = newVal.resolve;

                $ctrl.avisos = newVal.avisos;

                if($ctrl.avisos.length){
                    $ctrl.aviso = $ctrl.avisos[0];
                }

            }else{
                $ctrl.avisos = [];
            }
        });
    }],
});

core.factory('coreAvisos', ["$rootScope", "$q", function($rootScope, $q) {

    const coreAvisos = {};
    $rootScope.avisoCfg = null;

    coreAvisos.show=(avisos, callback = null)=>{
        return $q((resolve, reject) => {
            $rootScope.avisoCfg = {resolve, reject, avisos};
            $rootScope.$apply();

        }).then(() => {
            if (callback) {
                return callback(avisos)
            }
        });
    };

    coreAvisos.hide=()=>{
        $rootScope.avisoCfg = null;
    };

    return coreAvisos;
}]);